import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useState } from "react";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import { GetSaleInformationHeader } from "../../../models/settlement.model";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import StorefrontIcon from "@mui/icons-material/Storefront";

interface Props {
  headerData: GetSaleInformationHeader;
}
const SaleHeader = ({ headerData }: Props) => {
  const [isCollapes, setCollapse] = useState(true);
  const { customerInformation, saleInformation, storeInformation } =
    headerData || {};

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          backgroundColor: isCollapes ? "#F6F8F9" : "#fff",
        }}
      >
        <Box sx={{ width: "100%", height: "80%", padding: "10px 20px" }}>
          {isCollapes ? (
            <Collapsed
              customerInformation={customerInformation}
              storeInformation={storeInformation}
            />
          ) : (
            <Extended
              customerInformation={customerInformation}
              storeInformation={storeInformation}
              saleInformation={saleInformation}
            />
          )}
        </Box>
        <Box
          sx={{
            width: "100%",
            height: "20%",
            backgroundColor: "rgba(154,175,196,.1)",
            textAlign: "center",
            cursor: "pointer",
          }}
          onClick={() => setCollapse((prev) => !prev)}
        >
          {isCollapes ? (
            <ArrowDropDownRoundedIcon
              sx={{ color: "#9AAFC4", fontSize: "2rem" }}
            />
          ) : (
            <ArrowDropUpRoundedIcon
              sx={{ color: "#9AAFC4", fontSize: "2rem" }}
            />
          )}
        </Box>
      </Box>
    </div>
  );
};

const Extended = ({
  customerInformation,
  saleInformation,
  storeInformation,
}: GetSaleInformationHeader) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Grid
      container
      justifyContent={"space-between"}
      xs={12}
      flexDirection={isMobile ? "column" : "row"}
    >
      <Grid
        item
        container
        sx={{
          display: "flex",
          // flexDirection: "column",
          borderLeft: { xs: "", md: "1px solid #C1C7CB" },
          padding: "15px",
          alignItems: { xs: "center", md: "start" },
          justifyContent: { xs: "center", md: "start" },
        }}
        xs={12}
        sm={12}
        md={4}
        flexDirection={isMobile ? "column" : "row"}
        // justifyContent={isMobile ? "center" : "start"}
      >
        <Grid item>
          <AccountCircleRoundedIcon
            sx={{
              fontSize: "45px",
              color: "#9AAFC4",
              marginLeft: "15px",
            }}
          />
        </Grid>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: { xs: "center", md: "start" },
          }}
          padding={isMobile ? "15px" : ""}
        >
          <Typography
            sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "#1D4A87" }}
          >
            مشخصات متقاضی:
          </Typography>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            نام و نام خانوادگی:{" "}
            <span style={{ color: "#34495E" }}>
              {customerInformation?.customerFullName}
            </span>
          </Typography>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            کد ملی:{" "}
            <span style={{ color: "#34495E" }}>
              {customerInformation?.customerNationalCode}
            </span>
          </Typography>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            تاریخ تولد:{" "}
            <span style={{ color: "#34495E" }}>
              {customerInformation?.birthDate_Persian}
            </span>
          </Typography>
          <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
            تلفن همراه:{" "}
            <span style={{ color: "#34495E" }}>
              {customerInformation?.mobileNumber}
            </span>
          </Typography>
        </Grid>
      </Grid>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          borderLeft: { xs: "", md: "1px solid #C1C7CB" },
          padding: "15px",
          alignItems: { xs: "center", md: "start" },
        }}
        xs={12}
        sm={12}
        md={4}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "#1D4A87" }}
        >
          اطلاعات فروش:
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          تاریخ فروش:{" "}
          <span style={{ color: "#34495E" }}>
            {saleInformation?.saleDate_Persian}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          تاریخ بارگزاری فاکتور:{" "}
          <span style={{ color: "#34495E" }}>
            {saleInformation?.uploadInvoiceDate_Persian}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          شماره فاکتور:{" "}
          <span style={{ color: "#34495E" }}>
            {saleInformation?.factorNumber}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          تاریخ تایید فاکتور:{" "}
          <span style={{ color: "#34495E" }}>
            {saleInformation?.approveInvoiceDate_Persian ?? <>--</>}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          تاریخ تسویه حساب:{" "}
          <span style={{ color: "#34495E" }}>
            {saleInformation?.settledDate_Persian ?? <>--</>}
          </span>
        </Typography>
      </Grid>
      <Grid
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          padding: "15px",
          // paddingLeft: { xs: "", md: "8px" },
          alignItems: { xs: "center", md: "start" },
        }}
        xs={12}
        sm={12}
        md={4}
      >
        <Typography
          sx={{ fontWeight: "bold", fontSize: "1.1rem", color: "#1D4A87" }}
        >
          مشخصات فروشگاه:
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          نام فروشگاه:{" "}
          <span style={{ color: "#34495E" }}>
            {storeInformation?.storeName}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          شعبه فروشنده:{" "}
          <span style={{ color: "#34495E" }}>
            {storeInformation?.branchName}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          نوع فروش:{" "}
          <span
            style={{
              color: "#1D4A87",
              backgroundColor: "#EDF1F4",
              borderRadius: "5px",
              padding: "5px 7px",
              fontWeight: "bold",
            }}
          >
            {storeInformation?.saleType_Persian}
          </span>
        </Typography>
        <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
          وضعیت فروش:{" "}
          <span style={{ color: "#FB8C00", fontWeight: "bold" }}>
            {storeInformation?.saleStatus_Persian}
          </span>
        </Typography>
      </Grid>
    </Grid>
  );
};

const Collapsed = ({
  customerInformation,
  storeInformation,
}: Omit<GetSaleInformationHeader, "saleInformation">) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Grid
      container
      xs={12}
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <Grid
        item
        xs={12}
        md={9}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "90%",
        }}
        flexDirection={isMobile ? "column" : "row"}
      >
        <Typography
          sx={{ fontSize: "1.1rem", color: "#1D4A87", fontWeight: "600" }}
        >
          <AccountCircleRoundedIcon
            sx={{
              fontSize: "45px",
              color: "#9AAFC4",
              marginLeft: "15px",
            }}
          />
          {customerInformation?.customerFullName}
        </Typography>
        <Typography
          sx={{ fontSize: "1.1rem", color: "#1D4A87", fontWeight: "600" }}
        >
          کد ملی: {customerInformation?.customerNationalCode}
        </Typography>
        <Typography
          sx={{ fontSize: "1.1rem", color: "#1D4A87", fontWeight: "600" }}
        >
          فروشنده: {storeInformation?.sellerName}
        </Typography>
      </Grid>
      <Grid item xs={12} md={2} flexDirection={isMobile ? "column" : "row"}>
        {storeInformation?.saleType === "Online" ? (
          <Typography
            sx={{ fontSize: "1rem", color: "#1D4A87", textAlign: "center " }}
          >
            <LanguageRoundedIcon
              sx={{
                fontSize: "20px",
                marginLeft: "5px",
              }}
            />
            فروش آنلاین
          </Typography>
        ) : (
          <Typography sx={{ fontSize: "1rem", color: "#1D4A87" }}>
            <StorefrontIcon
              sx={{
                fontSize: "20px",
                marginLeft: "5px",
              }}
            />
            فروش حضوری
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default SaleHeader;
